import React, { createContext, useContext, useRef, useState, useEffect } from 'react';
import jpex from 'jpex';

var context = /*#__PURE__*/createContext(jpex);

var useJpex = (() => useContext(context));

function encase(dependencies, fn) {
  function encased() {
    const jpex = useJpex();
    const fnRef = useRef();

    if (fnRef.current == null) {
      const deps = dependencies.map(name => jpex.resolve(name));
      fnRef.current = fn.apply(jpex, deps);
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return fnRef.current.apply(null, args);
  }

  encased.encased = fn;
  return encased;
}

const {
  Provider
} = context;
function JpexProvider(_ref) {
  let {
    value,
    children,
    onMount,
    ...config
  } = _ref;
  const parent = useJpex();
  const mounted = useRef(false);
  const [container, setContainer] = useState(() => value ?? parent.extend(config));
  useEffect(() => {
    if (value && value !== container) {
      setContainer(value);
    }
  }, [value, setContainer]);

  if (!mounted.current) {
    mounted.current = true;

    if (onMount) {
      onMount(container);
    }
  }

  return /*#__PURE__*/React.createElement(Provider, {
    value: container
  }, children);
}

function useRegister() {
  const invoked = useRef(false);
  const jpex = useJpex();

  if (!invoked.current) {
    for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
      fns[_key] = arguments[_key];
    }

    fns.forEach(fn => fn(jpex));
    invoked.current = true;
  }
}

function useResolve(name, opts) {
  const jpex = useJpex();
  return jpex.resolve(name, opts);
}

/* eslint-disable @typescript-eslint/no-unused-vars */

function useResolveWith(name, namedParameters, opts) {
  const jpex = useJpex();
  return jpex.resolveWith(name, namedParameters, opts);
}

export { JpexProvider as Provider, encase, useJpex, useRegister, useResolve, useResolveWith };
